import React from 'react';
import WrappedContainer from '../components/wrapped/WrappedContainer';

const Wrapped2025Page: React.FC = () => {
  return <WrappedContainer />;
};

export default Wrapped2025Page;
